import { create } from 'zustand';
import { useMessagesStore } from './messagesStore';
import { ApiUtils } from '@shared/utils';
import { MessagesApi } from '@shared/api/rest';
import { RequestStrategyEnum } from '@shared/api/rest/models';

interface IMarkAsReadStore {
  loading: boolean;
  error: string | null;
  success: boolean;
  markAsRead: (messageId: string, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useMarkAsReadStore = create<IMarkAsReadStore>((set) => ({
  loading: false,
  error: null,
  success: false,

  markAsRead: ApiUtils.wrapperApi(async (messageId, signal) => {
    try {
      set({ loading: true, error: null, success: false });
      await MessagesApi.markAsRead(messageId, signal);
      useMessagesStore.getState().readMessage(messageId);
      set({ success: true, loading: false });
    } catch (error) {
      set({ error: ApiUtils.getApiError(error), loading: false });
      throw error;
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ loading: false, error: null, success: false }),
}));
